/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-10 17:22:52
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-21 11:07:19
 * @FilePath: /unifyxp-v2-store-portal/src/store/index.ts
 */
import * as Sentry from '@sentry/react';

import { EnumReducers } from './constants';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import language from '../../locale/IntlProvider/store';
import mainLayout from '../layout/store';
import productsList from '../pages/ProductsList/store';
import simpleProduct from 'src/pages/ProductEditor/SimpleProduct/Slice';
import productSet from '@/src/pages/ProductEditor/ProductSet/slice';
import variantProduct from '@/src/pages/ProductEditor/VariantProduct/Slice';
import stock from 'src/pages/Stock/Detail/slice';
import inventoryList from 'src/pages/Inventory/List/store';
import SalesChannelVersionContent from '@/src/pages/SalesCannelVersion/SalesChannelVersionContent/store';
import salesChannelContent from 'src/pages/SalesChannelContentEditor/slice';
import salesChannelProducts from 'src/pages/SalesChannelProductsConfig/slice';
import salesChannelLegal from 'src/pages/SalesCannelVersion/SalesChannelLegal/slice';
import salesChannelDiscountsFlashSale from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/FlashSale/FlashSaleList/slice';
import salesChannelDiscountsSubscriptionBuy from '@/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/List/slice';
import SalesChannelDiscountsDirectDiscount from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/List/slice';
import salesChannelDiscountsGiftPurchase from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseList/slice';
import storeProduct from 'src/pages/ProductEditor/slice';
import storeProductReview from 'src/pages/ProductReview/slice';
import searchListPageSearchConditions from 'src/constrains/BulkEditorTable/slice';
import salesChannelCategory from 'src/pages/SalesChannelCategory/slice';
import storeSettingTaxList from 'src/pages/Settings/Taxes/TaxListPage/slice';
import salesChannelCollectionList from 'src/pages/SalesCannelVersion/SalesChannelCollection/slice';
import salesChannelCollectionEdit from 'src/pages/SalesCannelVersion/SalesChannelCollection/slice/edit';
import currentSalesChannel from 'src/constrains/SalesChannelHOC';
import currentDatabase from 'src/constrains/CustomerDBGetter/slice';
import siderErrorSet from 'src/constrains/SiderErrorController/slice';
import configProvider from '@/src/constrains/GlobalProvider/slice';
import salesChannelLanguageSelect from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import styleSelect from 'src/constrains/SalesChannelStyleSelect/slice';
import PreviewSize from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/slice';
import ContentListLayerEditor from 'src/constrains/ResponsiveLayerEditor/slice';
import salesChannelProductDetailReducer from 'src/config/SiderConfig/slice/SalesChannelProductSiderConfigSlice';
import salesChannelCurrencySelect from 'src/constrains/SalesChannelMultiCurrencySelect/slice';

export { EnumReducers };

const reducer = combineReducers({
  mainLayout,

  language,
  productsList,
  simpleProduct,
  productSet,
  variantProduct,
  stock,
  inventoryList,
  SalesChannelVersionContent,
  salesChannelContent,
  salesChannelProducts,
  salesChannelLegal,
  [EnumReducers.salesChannelDiscountsFlashSale]: salesChannelDiscountsFlashSale,
  [EnumReducers.salesChannelDiscountsSubscriptionBuy]:
    salesChannelDiscountsSubscriptionBuy,
  [EnumReducers.SalesChannelDiscountsDirectDiscount]:
    SalesChannelDiscountsDirectDiscount,
  [EnumReducers.salesChannelDiscountsGiftPurchase]:
    salesChannelDiscountsGiftPurchase,
  storeProduct,
  [EnumReducers.configProvider]: configProvider,
  [EnumReducers.salesChannelCategory]: salesChannelCategory,
  [EnumReducers.storeProductReview]: storeProductReview,
  [EnumReducers.searchListPageSearchConditions]: searchListPageSearchConditions,
  salesChannelCollectionList,
  salesChannelCollectionEdit,
  [EnumReducers.siderErrorSet]: siderErrorSet,
  [EnumReducers.salesChannelLanguageSelect]: salesChannelLanguageSelect,
  [EnumReducers.storeSettingTaxList]: storeSettingTaxList,
  [EnumReducers.currentDatabase]: currentDatabase,
  [EnumReducers.currentSalesChannel]: currentSalesChannel,
  [EnumReducers.nativeSalesChannelTypeSelector]: styleSelect,
  [EnumReducers.responsivePreviewSize]: PreviewSize,
  [EnumReducers.responsiveLayerEditor]: ContentListLayerEditor,
  salesChannelProductDetail: salesChannelProductDetailReducer,
  [EnumReducers.salesChannelCurrencySelect]: salesChannelCurrencySelect,
});

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});
// Store
const store = configureStore({
  reducer,
  enhancers: [sentryReduxEnhancer],
});

const getState = () => {
  return store.getState();
};
const dispatch = store.dispatch;

export type AppDispatch = typeof store.dispatch;

export { store, getState, dispatch };
